import { Action, Reducer } from "redux";
import { SubcategoryState, SubcategoryTypes, SubcategoryActionTypes } from "./subcategoryTypes";
import {
	haskeyReducer,
	resetIsolatedReducer,
	updateGetIsolated,
	updateSaveIsolated,
} from "@/main/services/reducerUtils";

export const INITIAL_STATE: SubcategoryState = {
	subcategory: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const subcategoryReducer: Reducer<SubcategoryState> = (state: SubcategoryState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as SubcategoryActionTypes;
	switch (actionTypes.type) {
		case SubcategoryTypes.GET_SUBCATEGORY: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				subcategory: { ...state.subcategory, isLoading: true },
			};
		}
		case SubcategoryTypes.SAVE_SUBCATEGORY: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				subcategory: {
					...state.subcategory,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case SubcategoryTypes.RESET_REDUCER_SUBCATEGORY: {
			const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

			return {
				...state,
				subcategory: INITIAL_STATE.subcategory,
			};
		}
		default:
			return state;
	}
};

export default subcategoryReducer;
